import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Health from "../views/Health.vue";
import ExistingClient from "@/components/ui/ExistingClient.vue";
import Kyc from "@/components/widgets/Kyc.vue";
import { trackPageChange } from "@/helper/freshRelevance";
// import Testing from "@/components/ui/testing.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/existing",
    name:"Existing",
    component:ExistingClient
  },
  {
    path:"/kyc/:tokenvalue",
    name:"kyc",
    component: Kyc
  },
  {
    path: "/health",
    name: "Health",
    component: Health
  },
  // {
  //   path: "/testing",
  //   name:"testing",
  //   component:Testing
  // },
  // // otherwise redirect to home
  // { path: "*", redirect: "/" }
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes
});

router.afterEach((to, from) => {
  if (from.path === to.path) return;

  trackPageChange();
});

export default router;
